import router from '@/router'
import { createPinia } from 'pinia'
import piniaPluginPersist from '@/store/plugins/persist'
import type { App } from 'vue'

const pinia = createPinia()

export function setupPinia(app: App) {
  pinia.use(piniaPluginPersist)
  pinia.use(({ store }) => {
    // 这里安装插件
    store.$router = router
  })
  app.use(pinia)
}

export * from './modules/card'
export * from './modules/bank'
export * from './modules/app'
export * from './modules/webview'
export * from './modules/process'
